import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function MyTreasuresSection() {
  const { t } = useTranslation();

  const treasures = [
    {
      timeKey: 'today',
      timeKeyEn: 'todayEn',
      icon: 'ri-seedling-line',
      value: '誠信',
      valueEn: 'Integrity',
      color: 'text-primary-400',
      bg: 'bg-primary-50',
    },
    {
      timeKey: 'yesterday',
      timeKeyEn: 'yesterdayEn',
      icon: 'ri-heart-3-line',
      value: '感恩',
      valueEn: 'Gratitude',
      color: 'text-rose-300',
      bg: 'bg-rose-50',
    },
    {
      timeKey: 'thisWeek',
      timeKeyEn: 'thisWeekEn',
      icon: 'ri-shield-check-line',
      value: '承擔',
      valueEn: 'Accountability',
      color: 'text-accent-400',
      bg: 'bg-accent-50',
    },
  ];

  return (
    <section className="w-full bg-background-100/50">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <h2
          className="text-lg md:text-xl text-foreground-800 mb-2 text-center"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          {t('journey.myTreasures.title')}
          <span className="block text-xs text-foreground-400 font-normal mt-1">
            {t('journey.myTreasures.titleEn')}
          </span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8 max-w-2xl mx-auto">
          {treasures.map((item) => (
            <Link
              key={item.timeKey}
              to="/evidence"
              className={`${item.bg} border border-foreground-200/40 rounded-xl p-5 flex flex-col items-center text-center transition-all duration-300 hover:border-primary-200/60 hover:shadow-sm cursor-pointer`}
            >
              <i className={`${item.icon} ${item.color} text-xl mb-3`} />
              <p className="text-[10px] uppercase tracking-wider text-foreground-400 mb-1">
                {t(`journey.myTreasures.${item.timeKey}`)}
              </p>
              <p className="text-sm font-medium text-foreground-800">{item.value}</p>
              <p className="text-[10px] text-foreground-400">{item.valueEn}</p>
            </Link>
          ))}
        </div>

        <div className="text-center mt-5">
          <Link
            to="/evidence"
            className="inline-flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-line" />
            查看完整時間軸
          </Link>
        </div>
      </div>
    </section>
  );
}